import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import Signup from '../../components/auth/Signup';
import MinimalHeader from '../../components/layout/MinimalHeader';
import '../../styles/Auth.css';

const SignupPage = () => {
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { signup } = useAuth();
  const navigate = useNavigate();

  const handleSignup = async (email, password, confirmPassword, name) => {
    if (password !== confirmPassword) {
      return setError('Passwords do not match.');
    }
    if (password.length < 6) {
      return setError('Password must be at least 6 characters.');
    }

    setError('');
    setLoading(true);

    try {
      await signup(email, password, name);
      navigate('/');
    } catch {
      setError('Failed to create account. Try again.');
    }

    setLoading(false);
  };

  return (
    <>
      <MinimalHeader />
      <div className="auth-container">
        <h2 className="auth-title">Create Your Account</h2>
        <Signup onSubmit={handleSignup} loading={loading} error={error} />
        <p className="auth-footer">
          Already have an account? <Link to="/auth/login">Login</Link>
        </p>
      </div>
    </>
  );
};

export default SignupPage;
